import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100vw;
  height: calc(100vh - 54px);
  display: flex;
`;
